import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import { thunk } from 'redux-thunk';
import { createAuthMiddleware } from '@nike/oauth-client';

import authEvents from '../auth/events';
import config from '../config/config';
import rootReducer from './rootReducer';

export const HYDRATE_STATE = 'HYDRATE_STATE';

const initialState = {};

const configureStore = () => {
  const store =
    process.env.NODE_ENV !== 'test'
      ? createStore(
          makeHydratable(rootReducer, HYDRATE_STATE),
          initialState,
          composeWithDevTools(
            applyMiddleware(
              thunk,
              createAuthMiddleware({
                authEvents,
                config: Object.assign({}, config.oAuth, {
                  store: {
                    tokenName: '@qr-redirect-automation-ui/tokens',
                    hydrateName: '@qr-redirect-automation-ui/hydrate'
                  }
                })
              })
            )
          )
        )
      : createStore(
          makeHydratable(rootReducer, HYDRATE_STATE),
          initialState,
          composeWithDevTools(applyMiddleware(thunk))
        );

  if (process.env.NODE_ENV !== 'production') {
    // @ts-ignore - module.hot is available in webpack dev server
    if (module.hot) {
      // @ts-ignore
      module.hot.accept('./rootReducer', () => {
        store.replaceReducer(rootReducer);
      });
    }
  }

  return store;
};

export default configureStore;

function makeHydratable(reducer: any, hydrateActionType: string) {
  return function (state: any, action: any) {
    switch (action.type) {
      case hydrateActionType:
        return reducer(action.state, action);
      default:
        return reducer(state, action);
    }
  };
}

